import { Observable, of } from "rxjs";



export abstract class IAPIErrorHandlingService {
    public handleError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => { // Let the app keep running by returning an empty result.
          if (error.status === 500) {
           alert("Error: 500 (Internal Server Error)");
            return of(result as T);
          }else if (error.status === 404) {
            return of(result as T);
          }else{
            return of(result as T);
          }
        };
      }
} 